import React from "react";
import LegalPageRenderer from "../components/LegalPageRenderer";

const CookiePolicy = () => (
  <LegalPageRenderer slug="cookie-policy" testId="cookie-policy-page" />
);

export default CookiePolicy;
